<template>
	<div class="cell">
		<modal
			title=""
			button-style="tooltip"
			button-text="Bekijk aanpassingen"
			holder-class="configurator-options-wrapper"
			:open="openModal">
			<slot slot="button">
				<label
					class="configurator-options__item">
					<div class="configurator-options__shape configurator-options__shape--square configurator-options__shape configurator-options__shape--border-white configurator-options__shape--background-blue cursor-pointer">
						<div class="configurator-options__image-holder content-block__image-holder content-block__image-holder--contain">
							<div
								@click="openSuggestionModal">
								<span v-if="separateCover">{{ option.isCoverComparision ? "Omslagsuggestie" : "Binnenwerksuggestie" }}</span>
								<specification-canvas :data="canvasData"/>
							</div>
						</div>
					</div>

					<p class="configurator-block__label cursor-pointer">
						{{ formatInfo.fullName }}
					</p>
				</label>
			</slot>

			<div class="grid grid--gutters grid--ms-full grid--center-vertical">
				<div class="cell">
					<h3 class="content-block__title title--dot">Wijzigingen voor dit formaat</h3>
					<ul class="list list--svg">
						<li
							class="list__item"
							v-for="(reason, index) in option.reasonsFailed"
							:key="index">
							<svg class="icon icon--list icon--error">
								<use xlink:href="#alert--error"/>
							</svg>
							{{ reason }}
						</li>
					</ul>

				</div>
				<div class="cell">
					<div class="configurator-options__shape configurator-options__shape--square configurator-options__shape configurator-options__shape--background-blue cursor-pointer">
						<div class="configurator-options__image-holder content-block__image-holder content-block__image-holder--contain">
							<specification-canvas
								:data="canvasData"
								large/>
						</div>
					</div>
				</div>
			</div>
			<hr>
			<delivery-specification :format="option"/>
		</modal>
	</div>
</template>

<script>

import modal from "@/components/element/modal";
import deliverySpecification from "@/components/information/delivery-specification";
import specificationCanvas from "@/components/element/specification-canvas";

export default {
	name: "UploadSuggestion",
	props: {
		option: {
			type: Object,
			required: true
		}
	},
	components: {
		modal,
		deliverySpecification,
		specificationCanvas
	},
	data () {
		return {
			openModal: false
		};
	},
	computed: {
		canvasData () {
			return {
				isCover: this.option.isCoverComparision,
				customSize: this.option.isCustomSize,
				uploaded: this.option.isCoverComparision ? this.getFile.uploadSizes.cover : this.getFile.uploadSizes.content,
				original: {
					minHeight: this.option.minAllowedSize.height,
					maxHeight: this.option.maxAllowedSize.height,
					minWidth: this.option.minAllowedSize.width,
					maxWidth: this.option.maxAllowedSize.width
				},
				custom: {
					minHeight: this.option.minAllowedSize.height,
					maxHeight: this.option.maxAllowedSize.height,
					minWidth: this.option.minAllowedSize.width,
					maxWidth: this.option.maxAllowedSize.width
				},
				inRange: {
					height: this.option.heightInRange,
					width: this.option.widthInRange

				}
			};
		},
		uploadsAreComplete () {
			return this.$store.getters.uploadsAreComplete;
		},
		isCustomSize () {
			return this.$store.getters.isCustomSize;
		},
		formatInfo () {
			return this.option.productSize;
		},
		getFile () {
			return this.$store.getters.getFile;
		},
		separateCover () {
			return this.$store.getters.hasSeparateCover;
		}
	},
	methods: {
		openSuggestionModal () {
			this.openModal = false;

			setTimeout(function () {
				this.openModal = true;
			}.bind(this), 100);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/uploader/upload-suggestion.vue